import network from "@/api/network";

export default class Usercard {
  static async getUserCard(user_id, project_id) {
    return await network.get(`user/${user_id}/project/${project_id}/profile`, null, {});
  }

  static async getUserInfo(id) {
    return await network.get(`cards/info/${id}/`, null, {});
  }

  static async getUserCurators(id) {
    return await network.get(`cards/info/${id}/curators`, null, {});
  }

  static async updateUserInfo(data) {
    return await network.put(`cards/info/`, data, {});
  }

  static async getUserRelations(id) {
    return await network.get(`cards/relations/${id}/`, null, {});
  }

  static async updateUserRelations(data) {
    return await network.put(`cards/relations/`, data, {});
  }

  static async getUserPassport(id) {
    return await network.get(`cards/passports/${id}/`, null, {});
  }

  static async updateUserPassport(data) {
    return await network.put(`cards/passports/`, data, {});
  }

  static async getUserPassportScan(scan_id) {
    return await network.get(`cards/passports/scans/${scan_id}/`, null, {});
  }

  static async updateUserPassportScanFirst(data) {
    return await network.post(`cards/passports/scans/first`, data, {});
  }

  static async updateUserPassportScanSecond(data) {
    return await network.post(`cards/passports/scans/second`, data, {});
  }

  static async deleteUserPassportScanFirst(user_id) {
    return await network.delete(`cards/passports/scans/${user_id}/first`, null, {});
  }

  static async deleteUserPassportScanSecond(user_id) {
    return await network.delete(`cards/passports/scans/${user_id}/second`, null, {});
  }

  static async getUserCompanies(id) {
    return await network.get(`cards/${id}/companies`, null, {});
  }

  static async updateUserCompanies(data) {
    return await network.put(`cards/companies`, data, {});
  }

  static async getUserCompaniesCities(id) {
    return await network.get(`cards/${id}/companies/cities`, null, {});
  }

  static async getUserPrizes(project_id, id, page) {
    return await network.get(`cards/${project_id}/${id}/prizes`, { page, per_page: 10 }, {});
  }

  static async getUserBalance(project_id, id) {
    return await network.get(`cards/${project_id}/${id}/balance`, null, {});
  }

  static async getUserTransactions(project_id, id, page) {
    return await network.get(`cards/${project_id}/${id}/points`, { page, per_page: 10 }, {});
  }

  static async getUserHistory(id) {
    return await network.get(`cards/${id}/history`, null, {});
  }

  static async moveDataFromCurator(data) {
    return await network.post('user/relations/change/curator', data, {});
  }

  static async addPoints(data) {
    return await network.post('points/user/add', data, {});
  }

  static async subPoints(data) {
    return await network.post('points/user/subtract', data, {});
  }
}
